import { XIcon } from "lucide-react";
import { useDarkMode } from "@/hooks/useDarkMode";
import { StandardButton } from "./StandardButton";

interface ModalHeaderProps {
  title: string;
  onClose: () => void;
  className?: string;
  titleClassName?: string;
  firstFocusRef?: React.RefObject<HTMLButtonElement>;
  titleId?: string;
}

export function ModalHeader({
  title,
  onClose,
  className = "",
  titleClassName = "title-s-semibold",
  firstFocusRef,
  titleId,
}: ModalHeaderProps) {
  const isDark = useDarkMode();

  return (
    <header
      className={`py-4 min-h-14 flex items-center justify-between text-center px-6 border-b border-border-token-brand-minimal vsticky top-0 ${className}`}
    >
      <div className="flex-shrink-0 w-10" aria-hidden="true"></div>
      <h1
        id={titleId}
        className={`text-center text-fg-neutral-strong flex-1 px-4 ${titleClassName}`}
      >
        {title}
      </h1>
      <StandardButton
        ref={firstFocusRef}
        onClick={onClose}
        variant="closeModal"
        icon={<XIcon color={isDark ? "#A39FE8" : "#352FC3"} />}
        aria-label="Close modal"
        className="flex-shrink-0"
      />
    </header>
  );
}
